import clsx from 'clsx';
import { IMAGES } from 'src/assets';
import { UserAvatarProps } from './userAvatar.types';
import { Image } from './userAvatar.styles';

const UserAvatar = ({
  src = IMAGES.AVATAR_OWNER_DEFAULT,
  alt,
  small,
  className,
  onClick
}: UserAvatarProps) => {
  return (
    <Image
      src={src}
      alt={alt}
      className={clsx('_rounded-circle', className)}
      small={Boolean(small)}
      loading="lazy"
      onClick={onClick}
      onError={({ currentTarget }) => {
        currentTarget.onerror = null;
        currentTarget.src = IMAGES.AVATAR_OWNER_DEFAULT;
      }}
    />
  );
};

export default UserAvatar;
